import apiClient from "../api/setup";
import { TemaOption } from "./logic";

/** Temas disponíveis (endpoint público), com o total de perguntas validadas. */
export async function fetchTemasDisponiveis(): Promise<TemaOption[]> {
  const temas: TemaOption[] = [];
  let page = 1;
  let totalPages = 1;

  do {
    const { data } = await apiClient.get("/api/temas", { params: { page } });
    totalPages = data?.pagination?.totalPages ?? 1;
    for (const t of data?.data ?? []) {
      const levels = {
        easy: Number(t.easy ?? 0),
        medium: Number(t.medium ?? 0),
        hard: Number(t.dificult ?? 0),
      };
      temas.push({
        id: t.id,
        nome: t.nome,
        total: levels.easy + levels.medium + levels.hard,
        levels,
      });
    }
    page += 1;
  } while (page <= totalPages);

  return temas;
}

export async function fetchQuiz(temaId: number) {
  const { data } = await apiClient.get("/api/perguntas/quiz", {
    params: { tema: temaId },
  });
  return data as { easy: any[]; medium: any[]; dificult: any[] };
}
